import React from 'react';
import { cx } from '../../../customEmotion';
import { makeStyles } from '@material-ui/core/styles';

import { useMUITheme } from '../../styles/theme';
import MenuItem from '../../MenuItem';
import Checkbox from '../../Checkbox';

interface AccordionSelectItemProps {
  value: string;
  checked: boolean;
  indeterminate?: boolean;
  text: string;
  handleChangeValue: (value: string) => void;
}

export const useCustomStyle = makeStyles(theme => ({
  container: {
    padding: '8px 8px 8px 48px',
    backgroundColor: theme.palette.common.white,

    '&:hover': {
      backgroundColor: theme.palette.primary.lightest,
      '& .MuiSvgIcon-root': {
        color: theme.palette.primary.main,
      },
    },

    '&.Mui-selected': {
      backgroundColor: theme.palette.primary.lightest,
      '& > div': {
        backgroundColor: theme.palette.primary.main,
        color: theme.palette.common.white,
      },
    },
  },
  checkbox: {
    padding: 0,
    color: theme.palette.grey['A400'],
    width: '32px',
    height: '32px',
    alignSelf: 'center',

    '&:hover': {
      backgroundColor: 'none',
    },

    '& .MuiSvgIcon-root': {
      width: '16px',
      height: '16px',
    },

    '&.MuiCheckbox-indeterminate': {
      '& .MuiSvgIcon-root': {
        color: theme.palette.primary.main,
      },
    },
  },
  greyBlock: {
    minHeight: '30px',
    padding: '4px 8px',
    color: theme.palette.grey[600],
    backgroundColor: theme.palette.grey[100],
    fontSize: '14px',
    fontWeight: 500,
    lineHeight: '21px',
    borderRadius: '4px',
    alignSelf: 'center',
    whiteSpace: 'pre-wrap',
  },
}));

const AccordionSelectItem: React.FC<AccordionSelectItemProps> = ({
  value,
  checked = false,
  indeterminate,
  text,
  handleChangeValue,
}) => {
  const theme = useMUITheme();
  const customOptionStyle = useCustomStyle(theme);

  return (
    <MenuItem
      className={cx(customOptionStyle.container, { ['Mui-selected']: checked })}
      value={value}
      key={value}
      onClick={() => handleChangeValue(value)}
    >
      <Checkbox
        color="primary"
        checked={checked}
        className={customOptionStyle.checkbox}
        indeterminate={indeterminate}
      />
      <div className={customOptionStyle.greyBlock}>{text}</div>
    </MenuItem>
  );
};

export default AccordionSelectItem;
